//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.perfil || !state.perfil.data) return null;
    return Moment(String(state.perfil.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.perfis.length;
}

export default {
    dataFormatada,
	getCount
}